module.exports = __webpack_public_path__ + "img/login.84e1c9e3.svg";